module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vbassets/_next/static/images/hero_desktop-cf585e7e658ed71adf7f463d80ec4c91.jpg";